const getAllUserDayClose = (state) => state.dayCloseList;
const getDayClose = (state) => state.dayClose;

export default{
    getAllUserDayClose,
    getDayClose,
}